export default "__VITE_ASSET__BcJq8jqv__"